import React, { useRef, useState } from "react";
import {
  Layout,
  Row,
  Col,
  Typography,
  Button,
  Card,
  Space,
} from "antd";
import {
  TrophyOutlined,
  SafetyCertificateOutlined,
  StarOutlined,
  ThunderboltOutlined,
  SoundOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

import MainHeader from "../components/layout/MainHeader";
import MainFooter from "../components/layout/MainFooter";
import Reveal from "../components/components/common/Reveal";
import FloatingCTA from "../components/components/common/FloatingCTA";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const diferenciais = [
  { icon: <TrophyOutlined />, title: "+30 anos de experiência" },
  { icon: <SafetyCertificateOutlined />, title: "Controle de qualidade" },
  { icon: <StarOutlined />, title: "Acabamento premium" },
  { icon: <ThunderboltOutlined />, title: "Agilidade no atendimento" },
];

const servicos = [
  {
    title: "Banho de Ouro para Semijoias",
    description:
      "Serviço com foco em brilho, padronização e acabamento premium para peças com alto valor percebido.",
    image: "/images/banho-ouro.jpg",
    link: "/banho-de-ouro-semijoias",
  },
  {
    title: "Banhos Diversos",
    description:
      "Processos técnicos para peças com visual refinado, excelente acabamento e mais possibilidades de produção.",
    image: "/images/banhos-diversos.jpg",
    link: "/banho-de-prata-semijoias",
  },
  {
    title: "Vernizes",
    description:
      "Proteção e acabamento final para valorizar a peça, ampliar a durabilidade e reforçar a qualidade do produto.",
    image: "/images/vernizes.jpg",
    link: "/vernizes/cataforetico",
  },
];

function Home() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleAudio = () => {
    if (!videoRef.current) return;

    const nextMuted = !muted;
    videoRef.current.muted = nextMuted;

    videoRef.current
      .play()
      .catch((error) => console.log("Autoplay bloqueado:", error));

    setMuted(nextMuted);
  };

  return (
    <Layout style={{ background: "#111111" }}>
      <MainHeader />

      <Content>
        {/* HERO */}
        <section style={{ background: "#111111", padding: "40px 20px 0" }}>
          <div style={{ maxWidth: 1400, margin: "0 auto" }}>
            <div
              style={{
                maxWidth: 1000,
                margin: "0 auto",
                textAlign: "center",
                padding: "40px 0 48px",
              }}
            >
              <Reveal delay={200}>
                <Title
                  style={{
                    color: "#fff",
                    fontSize: "clamp(2.2rem, 6vw, 5rem)",
                    lineHeight: 1.05,
                    marginBottom: 24,
                  }}
                >
                  Banho de Semijoias e Bijuterias com acabamento premium para
                  marcas que exigem excelência.
                </Title>
              </Reveal>

              <Reveal delay={400}>
                <Paragraph
                  style={{
                    color: "rgba(255,255,255,0.75)",
                    fontSize: "clamp(1rem, 2vw, 1.2rem)",
                    maxWidth: 850,
                    margin: "0 auto 32px",
                  }}
                >
                  Atendemos marcas, fabricantes e revendedores que buscam
                  brilho, durabilidade, padronização e qualidade técnica em cada
                  peça.
                </Paragraph>
              </Reveal>

              <Space wrap size={16} style={{ justifyContent: "center" }}>
                <Reveal delay={600}>
                  <Button
                    className="btn-ouro"
                    size="large"
                    onClick={() => {
                      window.dataLayer = window.dataLayer || [];

                      window.dataLayer.push({
                        event: "leads",
                        lead_source: "botao_solicitar_orcamento_home",
                        page_path: window.location.pathname,
                      });

                      window.open(
                        "https://wa.me/5511996064416?text=Olá!%20Tenho%20interesse%20nos%20serviços%20de%20Banhos%20e%20Vernizes%20para%20semijoias%20e%20gostaria%20de%20falar%20com%20um%20especialista.",
                        "_blank"
                      );
                    }}
                  >
                    Solicitar orçamento
                  </Button>
                </Reveal>
              </Space>
            </div>

            {/* VIDEO */}
            <div
              style={{
                position: "relative",
                borderRadius: "24px 24px 0 0",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
                background: "#000",
              }}
            >
              <video
                ref={videoRef}
                autoPlay
                muted={muted}
                loop
                playsInline
                preload="auto"
                poster="/images/capa-video.jpg"
                style={{
                  width: "100%",
                  height: "clamp(260px, 52vw, 720px)",
                  objectFit: "cover",
                  display: "block",
                }}
              >
                <source src="/videos/homecompr.mp4" type="video/mp4" />
                Seu navegador não suporta vídeo.
              </video>

              {/* BOTÃO AUDIO */}
              <button
                onClick={toggleAudio}
                style={{
                  position: "absolute",
                  right: 16,
                  bottom: 16,
                  width: 42,
                  height: 42,
                  borderRadius: "50%",
                  border: "1px solid rgba(255,255,255,0.15)",
                  background: "rgba(0,0,0,0.6)",
                  backdropFilter: "blur(6px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "#d4b483",
                  zIndex: 2,
                }}
              >
                {muted ? "🔇" : <SoundOutlined />}
              </button>
            </div>
          </div>
        </section>

        {/* DIFERENCIAIS */}
        <section style={{ padding: "64px 20px", background: "#f7f7f7" }}>
          <Row gutter={[24, 24]} style={{ maxWidth: 1200, margin: "0 auto" }}>
            {diferenciais.map((item) => (
              <Col xs={24} sm={12} md={6} key={item.title}>
                <Card
                  hoverable
                  style={{ borderRadius: 20, textAlign: "center" }}
                >
                  <div style={{ fontSize: 28, color: "#d4b483" }}>
                    {item.icon}
                  </div>
                  <Title level={4}>{item.title}</Title>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* SERVIÇOS */}
        <section style={{ padding: "80px 20px", background: "#fff" }}>
          <div style={{ maxWidth: 1280, margin: "0 auto" }}>
            <Title level={2} style={{ textAlign: "center", marginBottom: 48 }}>
              Nossos principais serviços
            </Title>

            <Row gutter={[24, 24]}>
              {servicos.map((item) => (
                <Col xs={24} md={12} lg={8} key={item.title}>
                  <Link to={item.link}>
                    <Card hoverable cover={<img src={item.image} alt="" />}>
                      <Title level={4}>{item.title}</Title>
                      <Paragraph>{item.description}</Paragraph>
                    </Card>
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
        </section>
      </Content>

      <FloatingCTA triggerId="trigger-floating-cta" />
      <MainFooter />
    </Layout>
  );
}

export default Home;